import React, { useState } from 'react';

import {
    AccordionAnimate,
    AccordionAnimateBody,
    AccordionAnimateHeader,
} from '@r1-frontend/ui-react/components/accordions/AccordionAnimate';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import MultiLevelAccordionFAQ, { IMultiLevelAccordionFAQ } from './MultiLevelAccordionFAQ';

import * as ST from './styled';

export interface IAccordionFAQ {
    ask: string,
    response?: JSX.Element | string,
    responseUL?: Array<string>,
    response2?: string,
    multiLevelContentItem?: IMultiLevelAccordionFAQ,
}

export const AccordionFAQ: React.FC<IAccordionFAQ> = ({ ask, response, responseUL, response2, multiLevelContentItem }) => {
    const [isOpen, setIsOpen] = useState(false);
    const onToggleHandler = (status: boolean) => setIsOpen(status);
    if (multiLevelContentItem) {
        return <MultiLevelAccordionFAQ {...multiLevelContentItem}/>;
    }
    return (
        <AccordionAnimate isAnimate={true} duration={1} onToggle={onToggleHandler}>
            <AccordionAnimateHeader>
                <ST.Ask isOpen={isOpen}>{ask}</ST.Ask>
            </AccordionAnimateHeader>
            <AccordionAnimateBody>
                <ST.Response>
                    {response && <p>{response}</p>}
                    {responseUL && <ST.Ul>
                        {responseUL.map((itemUl, keyUl) => (
                            <ST.Li key={keyUl}>{itemUl}</ST.Li>
                        ))}
                     </ST.Ul>}
                     {response2 && <Paragraph4>{response2}</Paragraph4>}
                </ST.Response>
            </AccordionAnimateBody>
        </AccordionAnimate>
    );
};
